var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "base_info_window" }, [
    _c("div", { staticClass: "mark_content company_mark_content" }, [
      _c("div", { staticClass: "mark_content_top" }, [
        _c("div", { staticClass: "company_name" }, [
          _vm._v(_vm._s(_vm.allData.company_name))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "company_info" }, [
          _c("span", { staticClass: "score" }, [
            _vm._v("评分"),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.allData.score))
            ])
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "sort" }, [
            _vm._v("排名"),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.allData.sort))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mark_content_bottom" },
        _vm._l(_vm.allData.suggest, function(item, index) {
          return _c("div", { key: index, staticClass: "suggest" }, [
            _vm._v(_vm._s(item))
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b0f5f02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0f5f02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main_content/map/baseMap/base_info_window.vue
// module id = null
// module chunks = 